import { render, staticRenderFns } from "./busGoodsWarnList.vue?vue&type=template&id=0687ceb2"
import script from "./busGoodsWarnList.vue?vue&type=script&lang=js"
export * from "./busGoodsWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports